<template>
  <div class="products-302">

    <m-categories-306 @category="setProductCategory"/>

    <b-row v-if="!paginate">
      <b-col>
        <m-a class="float-left text-white" :href="{name:'Products',query:{category:selectedCategory}}">
          <h5 class="d-inline-block mx-1">مشاهده همه</h5>
          <b-icon-arrow-left/>
        </m-a>
      </b-col>
    </b-row>

    <m-products-wrapper :pause-if-category-not-found="true" :product-categories="productCategory">
      <div slot-scope="{products,pagination,changePageFunction}">
        <div class="row" v-if="products.length > 0">
          <b-col lg="4" class="my-2 rounded rounded-9 " v-for="product in products" :key='product.id'>

            <b-col class="product-302-card">
              <b-row align-v="center" align-h="center">

                <b-col cols="6">
                  <img v-b-modal="`modal-${product.id}`" :src="product.thumbnail" :alt="product.name"
                       class="mt-1 card-image ">
                </b-col>

                <b-col cols="6">
                  <h6 v-b-modal="`modal-${product.id}`" class="my-2">{{ product.name }}</h6>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col cols="6" class="text-center">
                  <m-product-price-100 v-b-modal="`modal-${product.id}`" class="text-white " :product="product"/>
                </b-col>

                <b-col cols="6">
                  <m-shopping-cart-controller-1 class="pb-3" :product="product"/>
                </b-col>
              </b-row>

            </b-col>


            <m-product-modal-302 :product="product"/>

          </b-col>
        </div>
        <h4 v-else class="text-center my-2">موردی یافت نشد</h4>

        <b-row v-if="paginate">
          <m-pagination-400 class="mx-auto my-3" :on-change-page="changePageFunction" :meta="pagination"/>
        </b-row>

      </div>
    </m-products-wrapper>

  </div>
</template>

<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Products302",
  components: {Swiper, SwiperSlide, directive, },
  props: {
    paginate: {
      default: false
    }
  },
  data() {
    return {
      productCategory: null
    }
  },
  methods: {
    setProductCategory(category) {
      console.log(category)
      this.productCategory = category
    }
  }
}
</script>

<style>
.products-302 .product-card-price {
  font-size: 10px !important;
}

.products-302 .product-price {
  font-size: 12px !important;
}


.product-302-card img {
  margin-top: 15px !important;
}

</style>

<style scoped>


.card-image {
  width: 112px !important;
  height: 112px;
}


.product-302-card {
  background: var(--secondary) !important;
  color: white !important;
  border-radius: 5px;
}

</style>